module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_c('div', {
    staticClass: "form-blank m2000"
  }, [_c('phone-code', {
    ref: "code",
    on: {
      "on-send": _vm.sendCode
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p2222"
  }, [_c('btn', {
    attrs: {
      "name": "获取输入",
      "theme": "primary",
      "block": true,
      "size": "lg"
    },
    on: {
      "on-click": _vm.submit
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6e479328!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/phone-code/demo.vue
// module id = 265
// module chunks = 5